module.exports = __webpack_public_path__ + "img/info.ef0f2e36.svg";